import { CopyIcon } from '@chakra-ui/icons';
import { FaEllipsisH } from 'react-icons/fa';
import { Disclosure, $ } from '@starberry/components';
import { format } from 'date-fns';
import { ActionTitle } from 'core/helpers/actions';

const ActionableListItem = {
  $: 'Grid',
  props: {
    templateColumns: (props) => ({ base: '1fr', md: props.actions ? '50px 1fr 50px' : '50px 1fr' }),
    gap: 6,
    autoFlow: '',
    overflow: 'visible',
    textAlign: 'left',
    justifyContent: 'center',
  },
  children: (props) => {
    return [
      {
        $: 'Flex',
        props: {
          m: '0',
          p: '0',
          alignItems: 'center',
          justifyContent: 'center',
        },
        children: [
          {
            $: 'Center',
            props: {
              backgroundColor: 'gray.100',
              boxSize: 12,
              borderRadius: 'full',
            },
            children: [
              {
                component: props.icon || CopyIcon,
              },
            ],
          },
        ],
      },
      {
        $: 'Flex',
        props: {
          flexDirection: 'column',
        },
        children: [
          props.action || props.data
            ? {
                $: 'Text',
                props: {
                  fontWeight: 'bold',
                  color: 'gray.600',
                  fontSize: 'md',
                },
                children: props.data
                  ? [
                      {
                        component: ActionTitle,
                        props: {
                          data: props.data,
                        },
                      },
                    ]
                  : props.action,
              }
            : {
                $: 'Text',
                props: {
                  fontWeight: 'bold',
                  color: 'gray.500',
                  fontSize: 'md',
                },
                children: $('description'),
              },
          {
            $: 'Text',
            props: {
              whiteSpace: 'nowrap',
              fontSize: 15,
              color: 'gray.500',
            },
            children: props.time ? format(new Date(props.time), 'dd/MM/yyyy · HH:mmaa') : '',
          },
        ],
      },
      props.actions && {
        $: 'Flex',
        props: {
          m: '0',
          p: '0',
          alignItems: 'center',
          justifyContent: 'center',
        },
        children: [
          {
            component: Disclosure,
            props: {
              render:
                () =>
                ({ isOpen, onClose, onOpen }) => {
                  return {
                    $: 'Stack',
                    props: {
                      direction: 'column',
                    },
                    children: [
                      {
                        component: 'IconButton',
                        props: {
                          'aria-label': 'icon',
                          icon: FaEllipsisH,
                          width: 10,
                          height: 10,
                          borderRadius: 'full',
                          backgroundColor: 'transparent',
                          onClick: () => onOpen,
                        },
                      },
                      {
                        $: 'ActionDialog',
                        isOpen: isOpen,
                        onClose: () => onClose,
                        data: props.data,
                      },
                    ],
                  };
                },
            },
          },
        ],
      },
    ];
  },
};

export default ActionableListItem;
